import IpcRouter from '@shared/ipc/IpcRouter.ts'

/**
 * 'unauthorized' — the gateway/WorkOS refused the target org (not a member, SSO/MFA
 * required, or the organization model is off); the current session is left intact.
 * 'failed' — transient error (offline, timeout, 5xx); the current session is left intact.
 */
export type SwitchOrganizationResult = 'switched' | 'unauthorized' | 'failed'

export interface AuthIpcRouterType {
  getConnectUrlForProvider: (
    provider: string,
    options?: { microsoftTenant?: 'common' | 'organizations' | 'consumers'; connectionId?: string },
  ) => Promise<string>
  getAuthProvider: () => Promise<'workos' | 'supabase'>
  getAccessToken: () => Promise<string>
  signOut: () => Promise<void>
  handleUnauthorized: (rejectedToken?: string) => Promise<string | null>
  switchOrganization: (organizationId: string) => Promise<SwitchOrganizationResult>
}

class AuthIpcRouter extends IpcRouter<AuthIpcRouterType> {
  constructor() {
    super('auth', {
      getConnectUrlForProvider: true,
      getAuthProvider: true,
      getAccessToken: true,
      signOut: true,
      handleUnauthorized: true,
      switchOrganization: true,
    })
  }
}

export default AuthIpcRouter
